// import { CodeMirrorFormField } from "./code-mirror-form-field";
import { Dialog } from "~/components/common/Dialog";
import { Button } from "~/components/ui";
import { Code } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useState } from "react";
import type { ScriptLookupType } from "~/types/ui";
import { CodeMirrorComponent } from "~/components/common/code-mirror";

export function CodeMirrorDialogFormField({
  value,
  onChange,
  options,
  notEditable = false,
  dialogButtonText,
}: {
  value: string;
  onChange: (val: string) => void;
  options?: {
    label: string;
    value: ScriptLookupType[]; // TODO Add other value type to lookup formulas
  }[];
  notEditable?: boolean;
  dialogButtonText?: string;
}) {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Dialog
      title={t("scripts.fields.code")}
      description={notEditable ? t("common.view") : t("common.edit")}
      width="98ww"
      open={openDialog}
      onOpenChange={setOpenDialog}
      trigger={
        <Button variant="outline" type="button" aria-label="Edit Selected">
          <Code className="h-[1.2rem] w-[1.2rem]" />
          {t(dialogButtonText ?? (notEditable ? "common.view" : "common.edit"))}
        </Button>
      }
      children={
        <CodeMirrorComponent
          value={value}
          height="600px"
          onChange={(val) => onChange(val)}
          notEditable={notEditable}
        />
      }
    />
  );
}
